export const sportCategories = [
  {
    slug: 'football',
    name: '足球赛事',
    icon: 'ri-football-line',
    description: '英超、西甲、欧冠等顶级联赛实时赔率',
    matchCount: 128,
    imageSeq: 'home-football-cat',
  },
  {
    slug: 'basketball',
    name: '篮球赛事',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲联赛专业盘口',
    matchCount: 86,
    imageSeq: 'home-basketball-cat',
  },
  {
    slug: 'tennis',
    name: '网球赛事',
    icon: 'ri-base-station-line',
    description: '大满贯、ATP、WTA赛事全覆盖',
    matchCount: 54,
    imageSeq: 'home-tennis-cat',
  },
  {
    slug: 'esports',
    name: '电竞比赛',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS:GO等热门电竞',
    matchCount: 42,
    imageSeq: 'home-esports-cat',
  },
  {
    slug: 'comprehensive',
    name: '综合赛事',
    icon: 'ri-medal-line',
    description: '斯诺克、高尔夫、F1赛车等更多选择',
    matchCount: 36,
    imageSeq: 'home-comprehensive-cat',
  },
];

export const hotMatches = [
  {
    id: 1,
    league: '英超联赛',
    homeTeam: '曼彻斯特城',
    awayTeam: '利物浦',
    homeLogo: 'ri-shield-line',
    awayLogo: 'ri-shield-flash-line',
    time: '2026-08-10 03:00',
    odds: { home: '2.15', draw: '3.50', away: '3.20' },
    status: 'upcoming',
  },
  {
    id: 2,
    league: 'NBA常规赛',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeLogo: 'ri-shield-star-line',
    awayLogo: 'ri-shield-user-line',
    time: '2026-08-09 10:30',
    odds: { home: '1.80', away: '2.05' },
    status: 'upcoming',
  },
  {
    id: 3,
    league: '欧冠联赛',
    homeTeam: '皇家马德里',
    awayTeam: '拜仁慕尼黑',
    homeLogo: 'ri-vip-crown-line',
    awayLogo: 'ri-shield-cross-line',
    time: '2026-08-12 03:00',
    odds: { home: '2.40', draw: '3.30', away: '2.80' },
    status: 'upcoming',
  },
  {
    id: 4,
    league: 'ATP大师赛',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeLogo: 'ri-user-star-line',
    awayLogo: 'ri-user-heart-line',
    time: '2026-08-11 16:00',
    odds: { home: '1.65', away: '2.25' },
    status: 'live',
  },
  {
    id: 5,
    league: '英雄联盟LPL',
    homeTeam: 'JDG京东',
    awayTeam: 'BLG哔哩哔哩',
    homeLogo: 'ri-game-line',
    awayLogo: 'ri-gamepad-line',
    time: '2026-08-10 17:00',
    odds: { home: '1.95', away: '1.85' },
    status: 'upcoming',
  },
  {
    id: 6,
    league: '中超联赛',
    homeTeam: '上海海港',
    awayTeam: '北京国安',
    homeLogo: 'ri-anchor-line',
    awayLogo: 'ri-flag-line',
    time: '2026-08-13 19:35',
    odds: { home: '1.72', draw: '3.80', away: '4.20' },
    status: 'upcoming',
  },
];

export const latestNews = [
  {
    id: 1,
    title: '2026赛季英超联赛前瞻：争冠格局分析与投注策略指南',
    excerpt: '新赛季英超联赛即将拉开帷幕，各支豪门球队纷纷补强阵容。本文深度剖析曼城、阿森纳、利物浦等争冠热门球队的夏季引援、战术变化及赛季前景，为您的投注决策提供专业参考。',
    category: '足球赛事',
    date: '2026-08-07',
    imageSeq: 'news-premier-league',
    tag: '深度分析',
  },
  {
    id: 2,
    title: 'NBA休赛期交易大盘点：谁是下赛季最大赢家？',
    excerpt: 'NBA休赛期重磅交易频出，多支球队阵容发生翻天覆地的变化。我们为您梳理关键转会信息，以及这些变动对新赛季投注赔率产生的深远影响。',
    category: '篮球赛事',
    date: '2026-08-06',
    imageSeq: 'news-nba-trade',
    tag: '交易动态',
  },
  {
    id: 3,
    title: '美网公开赛倒计时：男单夺冠热门赔率排行解析',
    excerpt: '本年度最后一项大满贯赛事即将在纽约开打，男单赛场的竞争格局异常激烈。本文为您带来最新夺冠赔率排名及专业解读。',
    category: '网球赛事',
    date: '2026-08-05',
    imageSeq: 'news-us-open',
    tag: '赛事前瞻',
  },
  {
    id: 4,
    title: '皇冠体育投注新手指南：从零开始玩转体育博彩',
    excerpt: '初次接触体育博彩？不用担心。这篇完整指南将带您了解基础术语、盘口类型、赔率计算方式以及实用的投注策略，助您快速上手。',
    category: '投注攻略',
    date: '2026-08-04',
    imageSeq: 'news-beginner-guide',
    tag: '新手必读',
  },
  {
    id: 5,
    title: '电竞博彩市场快速增长：2026年最值得关注的赛事盘点',
    excerpt: '电竞博彩已成为全球体育博彩市场增长最快的领域之一。本文盘点了2026年下半年最值得投注的电竞赛事和关键看点。',
    category: '电竞比赛',
    date: '2026-08-03',
    imageSeq: 'news-esports',
    tag: '行业趋势',
  },
  {
    id: 6,
    title: '皇冠体育APP全新升级：更流畅的投注体验与独家功能',
    excerpt: '皇冠体育移动端应用迎来重大版本更新，全新的界面设计、更快的赔率刷新、智能投注助手等多项创新功能正式上线。',
    category: '平台动态',
    date: '2026-08-02',
    imageSeq: 'news-app-upgrade',
    tag: '产品更新',
  },
];

export const stats = [
  { value: '15+', label: '年运营经验' },
  { value: '500万+', label: '注册用户' },
  { value: '50+', label: '覆盖体育项目' },
  { value: '99.9%', label: '系统稳定性' },
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '采用国际顶级加密技术，保障用户资金与信息安全，持有正规博彩运营牌照。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速到账',
    description: '提现申请秒级审核，支持多种支付方式，资金到账快至5分钟。',
  },
  {
    icon: 'ri-bar-chart-line',
    title: '实时赔率',
    description: '全球赛事赔率实时更新，与世界各大博彩交易所同步，确保最优赔率。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业客服',
    description: '7×24小时在线客服支持，专业团队随时为您答疑解惑，提供一对一VIP服务。',
  },
];